import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TemplateCard, type Template } from './TemplateCard'
import { Button } from '../ui/button'

const PAGE_SIZE = 18

interface TemplateGridProps {
  templates: Template[]
  onSelectTemplate: (template: Template) => void
  isTemplateLocked?: (template: Template) => boolean
}

export function TemplateGrid({ templates, onSelectTemplate, isTemplateLocked }: TemplateGridProps) {
  const { t } = useTranslation('projects')
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  const visibleTemplates = templates.slice(0, visibleCount)
  const hasMore = visibleCount < templates.length

  return (
    <div className="space-y-6">
      <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {visibleTemplates.map((template) => (
          <TemplateCard
            key={template.id}
            template={template}
            onClick={onSelectTemplate}
            locked={isTemplateLocked?.(template)}
          />
        ))}
      </div>
      {hasMore && (
        <div className="flex justify-center pt-2">
          <Button
            variant="outline"
            onClick={() => setVisibleCount((prev) => prev + PAGE_SIZE)}
          >
            {t('templateBrowser.showMore', { remaining: templates.length - visibleCount })}
          </Button>
        </div>
      )}
    </div>
  )
}
